import React, { useContext, useEffect } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import HelperEnv from '../helpers/HelperEnv';
import { setVehicleExamples } from '../actions/actionsAppTest';
import ExpandCollapseCriteria from '../components/setting/ExpandCollapseCriteria';

export default function ContTestHeader() {

    const globalstate = useContext(ReducerContext);
    const dispatch = useContext(ReducerDispatchContext);
    const widgetSFS = document.getElementById('widget-sfs');
    const widgetSfsVersion = widgetSFS && widgetSFS.getVersion && widgetSFS.getVersion();

    useEffect(() => {
        handleInit(globalstate, dispatch);
    });

    function handleInit(globalstate, dispatch) {
        if (!globalstate.isInitialised) {
            const defaultContext = JSON.parse(HelperEnv.getDefaultContext())
            if (HelperEnv.getDefaultContext() !== {} && HelperEnv.getEnabledConditionTestVehicles() === 'true') {
                dispatch(setVehicleExamples(defaultContext, globalstate.settings, globalstate, dispatch));
            }
        }
    }

    return (
        <nav className="navbar navbar-dark bg-primary text-light sticky-top shadow" style={{ zIndex: 999 }}>
            <div className="container-fluid">
                <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <h6 className="navbar-brand ">Online finance Test</h6>
                <ExpandCollapseCriteria />
                {(globalstate.env.widgetBpfVersion || globalstate.env.gwtestVersion)
                    && <h6 className="p-1 border border-info text-info version-info">
                        <small>{globalstate.env.gwtestVersion}{globalstate.env.envSuffix && ` - ${globalstate.env.envSuffix}`}</small>
                        {renderVersion()}
                    </h6>}
                {globalstate.env.envLabel && <h6 className={`p-1 alert alert-${globalstate.env.envTheme}`}>{globalstate.env.envLabel}</h6>}
            </div>
        </nav>
    );

    function renderVersion() {
        return (
            <React.Fragment>
                {globalstate.settings.widgetType.startsWith('WIDBPF') &&
                globalstate.env.widgetBpfVersion && <React.Fragment><br />
                    <small>{globalstate.env.widgetBpfVersion}</small></React.Fragment>}
                {globalstate.settings.widgetType.startsWith('WIDSFS') &&
                    widgetSfsVersion && <React.Fragment><br />
                        <small>Widget SFS version: {widgetSfsVersion.widget_version}</small>
                    </React.Fragment>}
            </React.Fragment>
        );
    }
}
